<script>
import { Bar } from "vue-chartjs";
import { mapGetters } from "vuex";

export default {
  props: ["dados"],
  extends: Bar,
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                var ranges = [
                  { divider: 1e15, suffix: "P" },
                  { divider: 1e12, suffix: "T" },
                  { divider: 1e9, suffix: "G" },
                  { divider: 1e6, suffix: "M" },
                  { divider: 1e3, suffix: "k" },
                ];

                function formatNumber(n) {
                  for (var i = 0; i < ranges.length; i++) {
                    if (n >= ranges[i].divider) {
                      return (
                        (n / ranges[i].divider).toString() + ranges[i].suffix
                      );
                    }
                  }
                  return n;
                }
                return formatNumber(value);
              },
            },
          },
        ],
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: -10,
          bottom: 15,
        },
      },
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true,
        text: "",
        position: "top",
      },
    },
  }),

  mounted() {
    this.montarGrafico();
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
  },

  watch: {
    dados() {
      this.montarGrafico();
    },
  },

  methods: {
    montarGrafico() {
      this.chartdata.datasets = [];
      this.chartdata.labels = this.dados.referencia;

      this.chartdata.datasets.push({
        label: "Saídas",
        backgroundColor: "#D60E2B",
        data: this.dados.saidas,
        datalabels: {
          anchor: "end",
          align: "end",
          clamp: true,
          padding: {
            bottom: -15,
          },

          formatter: function (value) {
            var ranges = [
              { divider: 1e15, suffix: "P" },
              { divider: 1e12, suffix: "T" },
              { divider: 1e9, suffix: "G" },
              { divider: 1e6, suffix: "M" },
              { divider: 1e3, suffix: "k" },
              { divider: 1, suffix: " " },
            ];

            function formatNumber(n) {
              for (var i = 0; i < ranges.length; i++) {
                if (n >= ranges[i].divider) {
                  if (ranges[i].divider === 1) {
                    return (
                      (Math.round(n) / ranges[i].divider).toString() +
                      ranges[i].suffix
                    );
                  } else {
                    return (
                      (Math.round(n) / ranges[i].divider)
                        .toFixed(1)
                        .toString() + ranges[i].suffix
                    );
                  }
                }
              }
              return null;
            }

            return formatNumber(value);
          },
        },
      });

      this.renderChart(this.chartdata, this.options);
    },
  },
};
</script>
